module.exports = __webpack_public_path__ + "static/media/m_eyeshape_monolid_brown.decee6c7.png";